import { Form, Formik, FormikHelpers } from 'formik';
import { Flex, Radio, VStack } from '@chakra-ui/react';
import RadioGroupFormikField from 'components/forms/RadioGroupFormikField';
import { PortfolioType } from '../types';
import { validationResultUtils } from 'utils/validation';
import { StepDetails } from '../StepDetails';
import { PCW_STEPS } from '../constants';
import { useWizardContext } from 'components/wizard/hooks/useWizardContext';
import { useWizardNavigation } from 'components/wizard/hooks/useWizardNavigation';
import { useWizardState } from 'components/wizard/hooks/useWizardState';
import InfoPopover from 'components/forms/InfoPopover';
import { FormattedMessage } from 'react-intl';

export interface PortfolioTypeFormData {
    portfolioType: PortfolioType;
}

const defaultValues: PortfolioTypeFormData = {
    portfolioType: 'econ-dispatch',
};

export function PortfolioTypeStep() {
    const { config } = useWizardContext();
    const { handleNext } = useWizardNavigation();
    const { formData, currentStep } = useWizardState();

    const initialValues: PortfolioTypeFormData = {
        ...defaultValues,
        ...config?.steps[PCW_STEPS.PCW_TYPE_STEP_ID]?.initialValues,
        ...formData[PCW_STEPS.PCW_TYPE_STEP_ID],
    };

    const handleSubmit = async (values: PortfolioTypeFormData, formik: FormikHelpers<PortfolioTypeFormData>) => {
        const result = await handleNext(values);
        if (result) {
            validationResultUtils.setFormikStatusAndErrors(result, formik);
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            enableReinitialize
        >
            {() => (
                <>
                    <StepDetails />
                    <Form
                        id={`form-${currentStep.id}`}
                        style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                    >
                        <Flex flexDir="column" flex="1" overflow="auto">
                            <RadioGroupFormikField id="portfolioType" name="portfolioType" label={''}>
                                <VStack spacing={4} align="start">
                                    <Flex gap={2} alignItems={'center'}>
                                        <Radio value={'econ-dispatch'}>
                                            <FormattedMessage id="wizard_pcw_type_selection_econ_dispatch_label" />
                                        </Radio>
                                        <InfoPopover
                                            info={
                                                <FormattedMessage id="wizard_pcw_type_selection_econ_dispatch_info" />
                                            }
                                        />
                                    </Flex>
                                    <Flex gap={2} alignItems={'center'}>
                                        <Radio isDisabled value={'load-dispatch'}>
                                            <FormattedMessage id="wizard_pcw_type_selection_load_dispatch_label" />
                                        </Radio>
                                        <InfoPopover
                                            info={
                                                <FormattedMessage id="wizard_pcw_type_selection_load_dispatch_info" />
                                            }
                                        />
                                    </Flex>
                                    <Flex gap={2} alignItems={'center'}>
                                        <Radio isDisabled value={'ars'}>
                                            <FormattedMessage id="wizard_pcw_type_selection_ars_label" />
                                        </Radio>
                                        <InfoPopover
                                            info={<FormattedMessage id="wizard_pcw_type_selection_ars_info" />}
                                        />
                                    </Flex>
                                </VStack>
                            </RadioGroupFormikField>
                        </Flex>
                    </Form>
                </>
            )}
        </Formik>
    );
}
